/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Digital_Content_UnlockInputs */

const en_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium digital content unlocks after purchase`)
};

const es_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El contenido digital premium se desbloquea tras la compra`)
};

const fr_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le contenu numérique premium se débloque après l'achat`)
};

const de_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-Digitalinhalt wird nach dem Kauf freigeschaltet`)
};

const ja_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入後にプレミアムデジタルコンテンツのロックが解除されます`)
};

const zh_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买后解锁高级数字内容`)
};

const ar_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتم فتح المحتوى الرقمي المميز بعد الشراء`)
};

const id_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten digital premium terbuka setelah pembelian`)
};

const it_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I contenuti digitali premium si sbloccano dopo l'acquisto`)
};

const ru_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиальный цифровой контент разблокируется после покупки`)
};

const pt_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo digital premium é desbloqueado após a compra`)
};

const ko_premium_digital_content_unlock = /** @type {(inputs: Premium_Digital_Content_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄 디지털 콘텐츠는 구매 후 잠금 해제됩니다`)
};

/**
* | output |
* | --- |
* | "Premium digital content unlocks after purchase" |
*
* @param {Premium_Digital_Content_UnlockInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const premium_digital_content_unlock = /** @type {((inputs?: Premium_Digital_Content_UnlockInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Digital_Content_UnlockInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_premium_digital_content_unlock(inputs)
	if (locale === "es") return es_premium_digital_content_unlock(inputs)
	if (locale === "fr") return fr_premium_digital_content_unlock(inputs)
	if (locale === "de") return de_premium_digital_content_unlock(inputs)
	if (locale === "ja") return ja_premium_digital_content_unlock(inputs)
	if (locale === "zh") return zh_premium_digital_content_unlock(inputs)
	if (locale === "ar") return ar_premium_digital_content_unlock(inputs)
	if (locale === "id") return id_premium_digital_content_unlock(inputs)
	if (locale === "it") return it_premium_digital_content_unlock(inputs)
	if (locale === "ru") return ru_premium_digital_content_unlock(inputs)
	if (locale === "pt") return pt_premium_digital_content_unlock(inputs)
	return ko_premium_digital_content_unlock(inputs)
});